import { createSelector } from '@ngrx/store';
import * as RA from 'ramda-adjunct';
import { getManagementState, ManagementState } from '../management.reducer';
import { adapter, LocationSetsState } from './location-sets.reducer';
import {asyncActionState} from '@emm/core/util/async-action-state';
import {LocationSetTypesSelectors} from '@emm/management/store/location-set-types/location-set-types.selectors';
import {LocationSet} from '@emm/core/models/location-set.model';
import {matchesLocationSetFilter} from '@emm/core/util/location-set-filter.util';

const getState = createSelector(getManagementState, (state: ManagementState) => state.locationSets);

const entitySelectors = adapter.getSelectors(getState);
const asyncActionStateSelectors = asyncActionState.getSelectors(getState);

const getSelectedTag = createSelector(getState, (state: LocationSetsState) => state.selectedTag);

const getSelected = createSelector(
    entitySelectors.selectEntities,
    getSelectedTag,
    (entities, selectedTag) => selectedTag && entities[selectedTag]
);

const getIsChainMenu = createSelector(
    LocationSetTypesSelectors.getSelectedTag,
    getSelectedTag,
    (locationSetTypeTag, locationSetTag) =>
        RA.isNonEmptyString(locationSetTypeTag) &&
        RA.isNonEmptyString(locationSetTag) &&
        locationSetTypeTag === 'CHAIN' &&
        locationSetTag === 'CHAIN'
);

const getFilter = createSelector(getState, (state) => state.filter);

const getChildLocationSets = createSelector(getState, (state) => state.childLocationSets);

const getFilteredLocationSets = createSelector(
    entitySelectors.selectAll,
    getFilter,
    (
        locationSets: LocationSet[],
        filter: string,
    ) => {
        let filterLocationSets: LocationSet[] = [];
        if (RA.isNonEmptyArray(locationSets)) {
            filterLocationSets =
                RA.isNonEmptyString(filter)
                    ? locationSets.filter((locationSet) =>
                        matchesLocationSetFilter(locationSet, filter))
                    : locationSets;
        }

        return filterLocationSets;
    }
);

export const LocationSetsSelectors = {
    entitySelectors,
    ...asyncActionStateSelectors,
    getFilter,
    getFilteredLocationSets,
    getChildLocationSets,
    getIsChainMenu,
    getSelected,
    getSelectedTag,
};
